// Styled component for Select field
import { Select } from "@mui/material";
import { styled } from "@mui/system";
export const StyledSelectField = styled(Select, {
  shouldForwardProp: prop => prop !== "variantType"
})(({ variantType }) => ({
  height: "56px",
  ...(variantType === "basic" && {
    position: "relative",
    "&::after": {
      content: "''",
      position: "absolute",
      width: "1px",
      height: "100%",
      backgroundColor: "#ddd",
      right: "56px",
      top: 0,
      zIndex: "1"
    },
    "& fieldset": {
      borderRadius: "8px",
      border: "solid 1px rgba(194, 194, 194, 0.56)"
    },
    "& svg": {
      position: "absolute",
      right: "20px",
      zIndex: 1
    },
    "& > div:nth-of-type(1)": {
      paddingRight: "4px !important"
    }
  }),
  ...(variantType === "combined" && {
    width: "93px !important",
    position: "absolute",
    right: "20px",
    fontSize: "16px",
    color: "#000",
    top: "50%",
    transform: "translate(0, -50%)"
  }),
  // shared fieldset styles (outside variant-specific blocks)
  "& fieldset": {
    borderRadius: "12px",
    border: "solid 1px rgba(194, 194, 194, 0.56)",
    "@media all and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      top: "0"
    }
  }
}));
// Styled component for chips container
export const StyledChips = styled("div")({
  display: "flex",
  flexWrap: "wrap"
});

// Styled component for individual chip items
export const StyledChip = styled("div")({
  margin: "2px"
});
